import { Component, HostBinding, inject, Input, OnInit } from '@angular/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { EmailPreviewRefreshService } from '../../services/email-preview-refresh.service';

import { ProductAnalyticsService } from '@vendasta/product-analytics';

export interface NetPromoterScoreBlock {
  rawHtml: string;
  renderType: string;
  redirectCheckBox: boolean;
}

const defaultType = 'button';

const defaultRedirectCheckBox = false;

export const blankNetPromoterScoreLinksBlock: NetPromoterScoreBlock = {
  renderType: defaultType,
  redirectCheckBox: defaultRedirectCheckBox,
  rawHtml: getRawHtml(defaultType, defaultRedirectCheckBox),
};
function getRawHtml(type: string, redirectToGoogle: boolean): string {
  if (type === 'button') {
    return `
      <table align="center" cellpadding="0" bgcolor="#FFFFFF" cellspacing="0" border="0" style="background:#FFFFFF;margin:0px auto;max-width:370px;font-size:0px;width:100%;">
           <tbody>
             <tr>
               <td height="10" style="font-size: 20px; line-height: 5px;" bgcolor="#FFFFFF">&nbsp;</td>
             </tr>
             <tr>
               <td style="word-wrap:break-word;font-size:0px;padding:0 25px;" bgcolor="#FFFFFF" align="center">
                     <div style="max-width: 464px;">

                       <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 8px; border: 1px solid #E0E0E0; border-collapse: separate;">
                           <tbody><tr>
                               <td align="center" style="padding-left: 0px; padding-right: 12px; padding-top: 10px; padding-bottom: 10px">

                                   <div style="height:44px"><div>
                               </td>
                               <td align="left" width="100%" style="padding-left: 4px; padding-right: 12px; padding-top: 10px; padding-bottom: 10px">
                                   <a href="{{net_promoter_score_url}}&RedirectToGoogle=${redirectToGoogle}" style="display: block; color: black; height: 100%;  margin: 0px; text-decoration: none; background: #FFFFFF; font-size: 17px; font-weight: 500; line-height: 120%; text-transform: none;  text-align: left; font-family: 'Open Sans', -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif;" target="_blank">
                                      Give feedback directly
                                   </a>
                               </td>
                           </tr></tbody>
                       </table>

                   </div>
               </td>
             </tr>
           </tbody>
         </table>
    `;
  } else if (type === 'inline') {
    let html = '<div>';
    for (let score = 10; score >= 0; score--) {
      html += `
        <div style="font-size: 30px; text-align: center;">
          <a href="{{net_promoter_score_redirect_url}}&Score=${score}&RedirectToGoogle=${redirectToGoogle}" style="padding: 10px; font-size: 16px; margin-top: 6px; background-color: #1e88e5; display: inline-block; color: white; cursor: pointer; text-decoration: none; width: 75%;" target="_blank">
            ${score === 0 ? '0 - Not Likely' : score + (score === 10 ? ' - Very Likely' : '')}
          </a>
        </div>
      `;
    }
    html += '</div>';
    return html;
  }
  return '';
}
@Component({
  selector: 'email-nps-block',
  imports: [GalaxyFormFieldModule, MatRadioModule, FormsModule, MatCheckboxModule, TranslateModule],
  templateUrl: './nps-block.component.html',
  styleUrl: './nps-block.component.scss',
})
export class NpsBlockComponent implements OnInit {
  private productAnalyticsService = inject(ProductAnalyticsService);
  @HostBinding('class') class = 'email-nps-block';
  @Input() content: NetPromoterScoreBlock;
  private emailPreview = inject(EmailPreviewRefreshService);

  valueChange(value: string): void {
    this.content.renderType = value;
    this.content.rawHtml = getRawHtml(value, this.content.redirectCheckBox);
    this.emailPreview.refresh();
  }
  valueChangeForCheckBox(value: boolean) {
    this.content.redirectCheckBox = value;
    let source: string;
    if (this.content.renderType === 'inline') {
      source = 'inline';
    } else {
      source = 'button';
    }
    this.content.rawHtml = getRawHtml(source, value);
    this.emailPreview.refresh();
  }

  ngOnInit(): void {
    this.productAnalyticsService.trackEvent('nps-block-added', 'email-template-create-activity', 'click');
  }
}
